import { getModel } from "@qpr/client-api-base/api/model";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import Query from "@qpr/client-api-base/querybuilder/Query";
import { usePeriod } from "backend/model/usePeriod";

import { useQuery } from "react-query";

type IScorecardResult = {
  id: string;
  name: string;
};

const useScorecardTopElement = (symbol?: string) => {
  const ctx = useAppContext();
  const periods = usePeriod();

  return useQuery<IScorecardResult | null>(
    `scorecard-${symbol}-${JSON.stringify(periods)}`,
    () => {
      if (symbol) {
        return getModel(ctx.model || "").then((models) => {
          const [m] = models;
          if (m && symbol) {
            return Query(m.id)
              .BySymbol({ symbol })
              .topelement()
              .fetchValues<IScorecardResult>()
              .then((list) => list[0]);
          }
          return null;
        });
      }
      return null;
    },
    { enabled: !!symbol, cacheTime: 5 * 100, staleTime: 4 * 100 }
  );
};

export default useScorecardTopElement;
